<div class="c__content">
  <div class="c__copyright-wrapper is-left">

    @if (logoLink?.url) {
      <sd-link class="c__logo" [link]="logoLink">
        <sd-icon name="icon-brand" />
      </sd-link>
    } @else {
      <div class="c__logo" >
        <sd-icon name="icon-brand" [brand]="brand" />
      </div>
    }

    @if (links) {
      <nav class="c__bottom-nav">
        <ul sd-list-inline class="{{isDevice$ ? 'is-l' : 'is-m'}}">
          @for (item of links; track item.linkName) {
            <li>
              <sd-link [link]="item" [theme]="themesConfig === themesEnum.light ? themesEnum.default : themesEnum.light">
                {{ item.linkName }}
              </sd-link>
            </li>
          }
        </ul>
      </nav>
    }
  </div>

  <div class="c__copyright-wrapper is-right">
    @if (changeCountryLink) {
      <div class="c__change-country">
        <sd-link
          [link]="{url: changeCountryLink}"
          [icon]="'icon-world' + (brand ? '-' + brand.toLowerCase() : '')"
          [buttonIconTitle]="changeCountryTitle"
          [titleHidden]="false"
          [theme]="themesConfig === themesEnum.light ? themesEnum.default : themesEnum.light"
          [size]="iconSize.xs"
          [isSmall]="true"
        />
      </div>
    }
    <p class="c__copyright is-body-s is-bold">
      {{ 'navigation.copyright' | translate : {brand: brand | titlecase}  }}
    </p>
  </div>
</div>
